"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageGlobalStyleMixin = void 0;
/** @class PageGlobalStyleMixin */
/** @method */
var PageGlobalStyleMixin = function PageGlobalStyleMixin() {
  return "\n    body {\n        margin: 0;\n    }\n";
};
exports.PageGlobalStyleMixin = PageGlobalStyleMixin;